import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileHeader } from './MobileHeader';
import { MobileBottomNav } from './MobileBottomNav';
import { CommandK } from '@/components/CommandK';
import { ToastProvider } from '@/components/ui/Toast';

/**
 * The authenticated app frame. Mobile-first:
 *   - Phones: header on top, full-width content, bottom-tab nav.
 *   - Desktop (md+): sidebar on the left, header bar on top, content fills the rest.
 *
 * The Cmd+K palette is mounted at the shell level so it's available from every
 * page without prop drilling.
 */
export function AppShell() {
  return (
    <ToastProvider>
      <div className="min-h-screen bg-kw-bg print:bg-white">
        <div className="flex">
          {/* Desktop sidebar — hidden on print so the auditor's printout
              has nothing but the page content + a clean margin. */}
          <div className="print:hidden">
            <Sidebar />
          </div>

          <div className="flex min-h-screen w-full flex-col md:pl-64 print:pl-0">
            {/* Headers — different on mobile vs desktop. Both hidden on print. */}
            <div className="print:hidden">
              <MobileHeader />
              <Header />
            </div>

            <main className="flex-1 px-4 py-5 sm:px-6 lg:px-8 lg:py-8 print:px-0 print:py-0">
              <Outlet />
            </main>

            {/* Bottom tab nav (mobile only) — sits above the iOS home indicator.
                Hidden on print. */}
            <div className="print:hidden">
              <MobileBottomNav />
            </div>
          </div>
        </div>

        {/* Cmd+K palette is interactive-only chrome — never appears on paper. */}
        <div className="print:hidden">
          <CommandK />
        </div>
      </div>
    </ToastProvider>
  );
}
